import { get, post, del } from '@api/request';

export async function fetchStratificationRuns(
  { ptdService },
  authenticationToken,
  { pageSize = 25, page = 1 }
) {
  const url = `${ptdService}/ptd/stratificationruns?pageSize=${pageSize}&page=${page}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createStratificationRun(
  { ptdService },
  authenticationToken,
  { payload }
) {
  const url = `${ptdService}/ptd/stratificationruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchStratificationRunDetail(
  { ptdService },
  authenticationToken,
  { runID }
) {
  const url = `${ptdService}/ptd/stratificationrun/${runID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchStratificationRunTaxingUnits(
  { ptdService },
  authenticationToken,
  { runID }
) {
  const url = `${ptdService}/ptd/stratificationrun/${runID}/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchStratificationRunTaxingUnitSummary(
  { ptdService },
  authenticationToken,
  { runID, taxingUnitID }
) {
  const url = `${ptdService}/ptd/stratificationrun/${runID}/summarybytaxingunit/${taxingUnitID}`
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteStratificationRun(
  { ptdService },
  authenticationToken,
  { runID }
) {
  const url = `${ptdService}/ptd/stratificationrun/${runID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateStratificationRun(
  { ptdService },
  authenticationToken,
  { runID }
) {
  const url = `${ptdService}/ptd/stratificationrun/${runID}/updatesalestrata`;
  const { body } = await post(authenticationToken, url);
  return body;
}